import { Vue, Component, Prop } from 'vue-property-decorator'
import { parse as parseDate } from 'date-fns'
import {
  DatepickerFilterField as IDatepickerFilterField,
  FilterFieldOperator,
  SelectionFilterField as ISelectionFilterField,
} from '../../../../types'

@Component
export default class DatepickerFilterField extends Vue {
  @Prop({ type: Object, required: true })
  private readonly data!: IDatepickerFilterField
  @Prop({ type: Boolean, default: true })
  private readonly range!: boolean

  private localValue: string[] = []

  private isRange = true

  private get hiddenCheckboxRange() {
    return !this.range
  }

  private formatDate(value: Date) {
    return value.toLocaleString('ru-RU', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
  }

  private created() {
    this.isRange = this.range

    this.$watch(
      () => {
        return [this.localValue.length, this.isRange].join('-')
      },
      () => {
        if (!this.localValue.length) {
          return
        }

        if (this.isRange) {
          if (this.localValue.length > 1) {
            const fromDate = parseDate(
              this.localValue[0],
              'yyyy-MM-dd',
              new Date()
            )

            const toDate = parseDate(
              this.localValue[1],
              'yyyy-MM-dd',
              new Date()
            )

            const text = [
              this.formatDate(fromDate),
              this.formatDate(toDate),
            ].join(' - ')

            const value: ISelectionFilterField = Object.freeze({
              text,
              field: this.data.name,
              label: this.data.label,
              value: this.localValue,
              operator: FilterFieldOperator.EQUAL,
            })

            this.$emit('select', value)
          }

          return
        }

        const date = parseDate(this.localValue[0], 'yyyy-MM-dd', new Date())

        const value: ISelectionFilterField = Object.freeze({
          text: this.formatDate(date),
          field: this.data.name,
          label: this.data.label,
          value: this.localValue,
          operator: FilterFieldOperator.EQUAL,
        })

        this.$emit('select', value)
      }
    )
  }
}
